<template>
    <div class="choseType">
        <div class="choseType-page box">
            <div class="choseType-page_l item">
                <div>
                    <div class="img_question">
                        <i class="iconfont icon-bangding"></i>
                        <p>账号绑定</p>
                    </div>
                    <p class="tips">将新学工号邮箱与现有邮箱账号绑定</p>
                    <el-button class="choseType-btn" type="primary"  @click="handleUrl('bind')">立即绑定</el-button>
                </div>
                 </div>
            <div class="choseType-page_r item">
                <div>
                    <div class="img_phone">
                        <i class="iconfont icon-suoding"></i>
                        <p>账号注销</p>
                    </div>
                    <p class="tips">将现有账号与邮箱数据全部删除</p>
                    <el-button class="choseType-btn" type="danger"  @click="handleUrl('block')">立即注销</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

  name: "choseType",
  data() {
    return {
    };
  },
    methods: {
        handleUrl(val){
            if(val == "bind"){
                this.$router.push({ name: 'BindCoremail'})
            }else{
                this.$router.push({ name: 'BlockCoremail'})
            }
        }
    }

};
</script>

<style scoped>
.choseType {
  width: 100%;
}
.box {
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.item {
  flex: 1;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item>div{
    width: 60%;
    min-width: 200px;
    height: 300px;
    background: #ffffff;
    text-align: center;
    border-radius: 5px;
    padding: 10px;
    margin: 10px;
}
.choseType-page {
  background: url("../../assets/img/bigBg/forget_bg.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}


.img_question,
.img_phone {
  text-align: center;
  margin-top: 40px;
}
.img_question i,
.img_phone i{
  font-size: 60px;
  color: #409EFF;
  height: 75px;
  line-height: 75px;
}
.img_question p,
.img_phone p {
    line-height: 50px;
}
.choseType-btn{
    margin-top: 35px;
    width: 80%
}
.tips{
    color: #999;
    font-size: 14px;
    height: 45px;
}
</style>



// WEBPACK FOOTER //
// src/page/Coremail/choseType.vue